<template>
  <div>
    <el-button @click="onPickTimezone" class="mr-2">Pick Timezone</el-button>

    <span>{{selected_timezone}}</span>

    <!-- INFO: Won't work with $refs -->
    <!-- <portal to="modal-target-goal-details"></portal> -->

    <el-dialog
      :visible.sync="dialog_visible"
      title="Pick a timezone">

      <div id="map-container">
        <vue-timezone-picker ref="tzpicker" :options="options" v-model="timezone" ></vue-timezone-picker>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onClickGuess">Set time zone to your timezone ({{timezone_guess}})</el-button>
        <el-button @click="dialog_visible = false">Cancel</el-button>
        <el-button type="primary" @click="onConfirmModal">OK</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import VueTimezonePicker from "./VueTimezonePicker";
import moment from '@/moment-gp.js';

export default {
  props: {
    value: {
      Default: []
    },
  },
  data () {
    return {
      dialog_visible: false,
      timezone_guess: moment.tz.guess(),
      timezone: moment.tz.guess(), // 'Europe/Berlin'
      options: {
        width: 500,
        height: 250,
        // defaultValue: {
        //   value: 'Europe/Berlin',
        //   attribute: 'zonename'
        // },
        quickLink: [
          {
            // "PST": "PST",
            // "MST": "MST",
            // "CST": "CST",
            // "EST": "EST",
            // "GMT": "GMT",
            // "IST": "IST"
            'NYC': 'America/New_York',
            'CET': 'Europe/Berlin'
          }
        ],
        selectClass: 'Cbox',
        filterBoxClass: 'Cbox',
        mapHoverType: 'zonename',
        showHoverText: false
      }
    }
  },
  created() {
    if ( this.value ) {
      this.timezone = this.value;
    } else {
      this.timezone = this.timezone_guess;
    }
  },
  computed: {
    selected_timezone() {
      if ( typeof this.timezone === "string" ) {
        return this.timezone;
      }
      if ( this.timezone !== null && typeof this.timezone === 'object' ) {
        let selectedTZ = this.timezone[0];
        return selectedTZ ? selectedTZ.timezone : 'Undefined';
      }
      return 'Timezone not set';
    }
  },
  methods: {
    onPickTimezone() {
      this.dialog_visible = true;

      // HACK!
      setTimeout(() => {
        this.$refs.tzpicker.setValue(this.timezone);
      }, 200)
    },
    onConfirmModal() {
      this.$emit("input", this.selected_timezone);
      this.dialog_visible = false;
    },
    onClickGuess() {
      this.$refs.tzpicker.setValue(this.timezone_guess);
    }
  },
  components: {
    VueTimezonePicker
  }
}
</script>

<style>
@media (min-width: 768px) {
  .modal-xxl {
    width: 90%;
    max-width: 1200px;
  }
}
#map-container {
  display: block;
  margin: auto;
}
.timezone-map polygon:hover {
  cursor: pointer;
}
.Cbox.filter-box .quick-link span {
  display: inline;
  height: unset;
  line-height: unset;
}
.Cbox.filter-box .quick-link {
  overflow: visible;
  margin: 0;
  padding: 0;
  height: unset;
  line-height: unset;
}
/* .Cbox .quickLink {
  width: 52%;
  float: right;
  padding-bottom: 11px;
  overflow-x: auto;
  white-space: nowrap;
  overflow-y: hidden;
}
.Cbox .quickLink span:hover {
  color: #fff;
  background-color: #496a84;
  cursor: pointer;
}
.Cbox select {
  width: 45%;
  float: left;
  height: 27px;
  padding: 0px 0px 0px 10px;
}
.Cbox .quickLink span.active {
  color: #fff;
  background-color: #496a84;
}
.Cbox .quickLink span {
  font-weight: 300;
  border-radius: 3px;
  color: #000;
  background-color: #fff;
  border: solid 1px #ccc;
  margin-left: 10px;
  font-size: 9px;
  padding: 4px 6px 4px 6px;
}
.filter-box .quick-link span {
  border: #999 1px solid;
}
.Cbox .country-lov{
  text-align: left;
} */
</style>
